<template>
  <v-app id="app">   

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="primary"
      app
      fixed     
    >
   
      <v-app-bar-nav-icon
        color="twhite"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>

     
     
      <v-toolbar  dense flat color="primary" fixed app>
        
         <v-btn  color="primary"
            flat		
            x-large
            class="white--text subtitle-1"
            to="/"
            >
            <h3 class="white--text mb-2 subtitle-1 text-xs-center" style="font-weight: 900; text-shadow: 3px 2px #000000">SaasCade Tech</h3>
            </v-btn>
        <v-spacer></v-spacer>
         <v-toolbar-title class="ml-0 pl-3 hidden-sm-and-down">
          <v-card color="primary">
          <v-btn
            color="primary"
            v-bind="attrs"
            v-on="on"
            class="white--text"
            to="/explore-static-websites"
            >
              HTML Websites
            </v-btn>
        
         <v-btn
            color="primary"
            round
            v-bind="attrs"
            v-on="on"
            class="white--text"
            to="/explore-websites"
            >
              Wordpress
            </v-btn>
         <v-btn
            color="primary"
            round
            v-bind="attrs"
            v-on="on"
            class="white--text"
            to="/explore-ecommerce"
            >
              E-Commerce
            </v-btn>
             <v-btn
            color="primary"
            round
            v-bind="attrs"
            v-on="on"
            class="white--text"
            to="/explore-services"
            >
              Services
            </v-btn>
         <template>
            <v-menu
              open-on-hover
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn

                  color="primary"
                  round
                  v-bind="attrs"
                  v-on="on"
                  class="white--text center"
                >
                  About Us
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                  v-for="(item, index) in aboutUs"
                  :key="index"
                  :to="item.path"
                >
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
        </template>
          </v-card>
      </v-toolbar-title>

      <v-spacer></v-spacer>
       
  <v-toolbar-items flat class="hidden-sm-and-down">
           
     <template  v-if="authenticated">
        <v-card flat dense color="primary " class="justify-center">
          <template>
            <v-menu
              open-on-hover
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  
                  v-bind="attrs"
                  v-on="on"
                  class="white--text center rounded"
                >
                  Orders
                </v-btn>
              </template>             

              <v-list>
                <v-list-item
                  v-for="(item, index) in orders"
                  :key="index"
                  :to="item.path"
                >
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
        </template>

         <template>
            <v-menu
              open-on-hover
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  class="white--text center rounded"
                >
                  My Account
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                  v-for="(item, index) in account"
                  :key="index"
                  :to="item.path"
                >
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
        </template>


        <v-badge right overlap>
          <template v-slot:badge>
            <span class="font-weight-bold">{{ getBookmarkAmount }}</span>
          </template>
          <v-btn
            icon
            color="twhite"
            :to="{ name: 'shortlist', params: { id: $store.state.userId } }"
          >
            <v-icon>bookmarks</v-icon>
          </v-btn>
        </v-badge>
        <template v-if="getNotificationStatus">
          <v-btn icon color="twhite" to="/message">
            <v-icon>notifications</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-btn icon color="error" to="/message">
            <v-icon>notifications</v-icon>
          </v-btn>
        </template>

        <v-menu open-on-hover bottom offset-y transition="slide-y-transition">
          <template v-slot:activator="{ on }">
            <v-btn  fab color="twhite" v-on="on" small>
              <span class="font-weight-bold title primary--text">{{
                getName
              }}</span>
            </v-btn>
          </template>
          <v-list>
            <v-list-item to="/signout">
              <v-icon>mdi-logout</v-icon>
              <v-list-item-title color="twhite">Sign Out</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        </v-card>
      </template>
      
      
    <template v-else>
        <v-btn small to="/signin" class="accent rounded subtitle-2  ">
         Login/SignUp

        </v-btn>
      </template>


      </v-toolbar-items>
      
      </v-toolbar>
     
  </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      :width="250"
      fixed
      app
    >
      <v-img
        :src="require('./assets/logo.png')"
        height="100"
        width="200"
        contain
      >
      </v-img>

      <template v-if="$store.state.userId != ''">
        <h4 class="subtitle-1 text-left pa-6 font-weight-regular black--text">
          Hello, {{ $store.state.displayName }}
        </h4>
        <v-list v-for="(item, i) in items" :key="i">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.icon"
            :append-icon="item['icon-alt']"
            color="accent"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2">
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
              <v-list-item
                avatar
                v-for="(child, i) in item.children"
                :key="i"
                :to="child.path"
              >
              <v-list-item-action v-if="child.icon">
                <v-icon medium color="primary">
                  {{ child.icon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="primary--text subtitle-2">
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
             
          </v-list-group>
          
        </v-list>
          <v-col>
         <v-btn
            block
            class=" info subtitle-2  pa-auto ma-auto "
            :to="{ name: 'shortlist', params: { id: $store.state.userId } }"
          >
          Shortlist
          </v-btn>
          </v-col>
          <v-col>
          <v-btn to="/signout" block class="accent pa-auto ma-auto subtitle-2  ">
            Logout
          </v-btn>
          </v-col>-
      
      </template>

      <template v-else>
        <v-list v-for="(item, i) in general" :key="i">
          <v-list-group
            color="accent"
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.icon"
            :append-icon="item['icon-alt']"
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2">
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
              avatar
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.path"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon medium color="primary">
                  {{ child.icon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="primary--text subtitle-2">
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            
          </v-list-group>
        </v-list>
                <v-row>
        <v-btn to="/signin" block class="accent  subtitle-2  ">
         Login/SignUp

        </v-btn>
      </v-row>
      </template>
     
    </v-navigation-drawer>

    <v-content>
        <router-view></router-view>
    </v-content>

    <v-footer padless>
      <v-card flat tile width="100%" class="primary text-center">
        <v-card-text>
          <span class="white--text">Find us on social media:</span>
          <v-btn
            v-for="(icons, i) in iconsFooter"
            :key="i"
            color="white"
            target="_blank"
            :href="icons.path"
            icon
          >
            <v-icon size="24px">{{ icons.icon }}</v-icon>
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>
        <v-row justify="center" no-gutters>
          <span class="white--text"
            >Important links:

            <v-btn
              v-for="link in links"
              :key="link.text"
              color="white"
              text
              
              class="my-2"
              :to="link.path"
            >
              {{ link.text }}
            </v-btn>
          </span>
          <v-col class="primary text-center white--text" cols="12">
            <span class="white--text">Copyrights: </span>

            {{ new Date().getFullYear() }} —
            <strong>SAASCADE TECH PVT LTD</strong>
          </v-col>
        </v-row>
      </v-card>
    </v-footer>

    <v-speed-dial vmodel="fab1" slide-y-reverse-transition bottom left fixed>
      <template v-slot:activator>
        <v-btn fab color="success">
          <v-icon v-if="fab1">mdi-close</v-icon>
          <v-icon v-else>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-btn
        fab
        small
        class="success"
        color="white"
        href="https://wa.me/919901561787"
        target="_blank"
      >
        <v-icon>mdi-whatsapp</v-icon>
      </v-btn>
      <v-btn
        fab
        small
        class="primary"
        color="white"
        href="skype:live:.cid.17128701ef37ac30?chat"
        target="_blank"
      >
        <v-icon>mdi-skype</v-icon>
      </v-btn>
      <v-btn
        fab
        small
        class="info"
        color="info"
        href="https://m.me/saascadetech.sct.9"
        target="_blank"
      >
        <v-icon>mdi-facebook-messenger</v-icon>
      </v-btn>
     
    </v-speed-dial>
  </v-app>
</template>

<script>
import { db } from "@/Firebase";
import axios from "axios";

export default {
  name: "App",
  data: () => ({
    fab1: false,
    rfid: "",
    rfid1: "",
    dialog: false,
    drawer: 0,
    iconsFooter: [
      {
        icon: "mdi-facebook",
        path: "https://www.facebook.com/saascadetech.sct.9"
      },
      { icon: "mdi-twitter", path: "https://twitter.com/saascade" },
      {
        icon: "mdi-linkedin",
        path: "https://www.linkedin.com/in/saascade-tech-b6bb821a2/"
      }
    ],
    links: [
      { icon: "important_devices", text: "Website", path: "/explore-websites" },
      { icon: "shopping_cart", text: "E-Commerce", path: "/explore-ecommerce" },
      { icon: "language", text: "Services", path: "/explore-services" },
      { icon: "group", text: "About Us", path: "/aboutus" },
      { icon: "contacts", text: "Contact Us", path: "/contactus" },
    ],
    items: [
      {
        icon: "launch",
        "icon-alt": "keyboard_arrow_down",
        text: "Products",
        subtext:
          "Explore various templates for websites,ecommerce,softwares and services",
        model: false,
        children: [

           {
            icon: "code",
            text: "HTML Websites",
            path: "/explore-static-websites"
          },
          {
            icon: "important_devices",
            text: "Wordpress",
            path: "/explore-websites"
          },
          {
            icon: "shopping_cart",
            text: "E-Commerce",
            path: "/explore-ecommerce"
          },
          { icon: "language", text: "Services", path: "/explore-services" }
        ]
      },
      {
        icon: "shopping_cart",
        "icon-alt": "keyboard_arrow_down",
        text: "My Orders",
        subtext: "All your orders are here",
        model: false,
        children: [
          {
            icon: "important_devices",
            text: "Website",
            path: "/orders-website"
          },
          {
            icon: "shopping_cart",
            text: "E-Commerce",
            path: "/orders-ecommerce"
          },
          { icon: "language", text: "Services", path: "/orders-services" }
        ]
      },
      {
        icon: "settings",
        "icon-alt": "keyboard_arrow_down",
        text: "Account",
        subtext: "Account related details",
        model: false,
        children: [
          { icon: "perm_identity", text: "Profile", path: "/profile" },
          { icon: "account_balance", text: "Billing", path: "/billing" },
          { icon: "loyalty", text: "Referral", path: "/referral" },
          { icon: "message",text: "Notifications", path: "/message"}
        ]
      },
      {
        icon: "face",
        "icon-alt": "keyboard_arrow_down",
        text: "About Us",
        subtext: "About SaasCadeTech",
        model: false,
        children: [
          { icon: "group", text: "About Us", path: "/aboutus" },
          { icon: "contacts", text: "Contact Us", path: "/contactus" },
          {
            icon: "mdi-cash-usd",
            text: "Refund Policy",
            path: "/refundpolicy"
          },
          {
            icon: "verified_user",
            text: "Privacy Policy",
            path: "/privacypolicy"
          },
          {
            icon: "note",
            text: "Terms & Conditions",
            path: "/termsandconditions"
          }
        ]
      }
    ],
    general: [
      {
        icon: "launch",
        "icon-alt": "keyboard_arrow_down",
        text: "Products",
        subtext:
          "Explore various templates for websites,ecommerce,softwares and services",
        model: false,
        children: [
           {
            icon: "codes",
            text: "HTML Websites",
            path: "/explore-static-websites"
          },
          {
            icon: "important_devices",
            text: "Wordpress",
            path: "/explore-websites"
          },
          {
            icon: "shopping_cart",
            text: "E-Commerce",
            path: "/explore-ecommerce"
          },
          { icon: "language", text: "Services", path: "/explore-services" }
        ]
      },
      {
        icon: "face",
        "icon-alt": "keyboard_arrow_down",
        text: "About Us",
        subtext: "About SaasCadeTech",
        model: false,
        children: [
          { icon: "group", text: "About Us", path: "/aboutus" },
          { icon: "contacts", text: "Contact Us", path: "/contactus" },
          { icon: "mdi-cash-usd",text: "Refund Policy",path: "/refundpolicy"},
          {
            icon: "verified_user",
            text: "Privacy Policy",
            path: "/privacypolicy"
          },
          {
            icon: "note",
            text: "Terms & Conditions",
            path: "/termsandconditions"
          }
        ]
      }
    ],
    menu: [
      { icon: "important_devices", text: "HTML Websites", path: "/explore-static-websites" },
      { icon: "important_devices", text: "Wordpress", path: "/explore-websites" },
      { icon: "shopping_cart", text: "E-Commerce", path: "/explore-ecommerce" },
      { icon: "language", text: "Services", path: "/explore-services" }
    ],
    orders: [
          {
            icon: "important_devices",
            text: "Website",
            path: "/orders-website"
          },
          {
            icon: "shopping_cart",
            text: "E-Commerce",
            path: "/orders-ecommerce"
          },
          { icon: "language", text: "Services", path: "/orders-services" }
        ],
    aboutUs: [
          { icon: "group", text: "About Us", path: "/aboutus" },
          { icon: "contacts", text: "Contact Us", path: "/contactus" },
          {
            icon: "mdi-cash-usd",
            text: "Refund Policy",
            path: "/refundpolicy"
          },
          {
            icon: "verified_user",
            text: "Privacy Policy",
            path: "/privacypolicy"
          },
          {
            icon: "note",
            text: "Terms & Conditions",
            path: "/termsandconditions"
          }
      ],
      account: [
          { icon: "perm_identity", text: "Profile", path: "/profile" },
          { icon: "account_balance", text: "Billing", path: "/billing" },
          { icon: "loyalty", text: "Referral", path: "/referral" }
      ]
  }),
  created() {
    let urlParams = new URLSearchParams(window.location.search);
    this.rfid = urlParams.get("rfid");
    if (this.rfid != null) localStorage.setItem("saascadetechrfid", this.rfid);
    this.rfid1 = localStorage.getItem("saascadetechrfid");
    if (this.rfid1 == "" || this.rfid1 == "null") {
      this.$store.commit("addRfid", "default");
      localStorage.setItem("saascadetechrfid", "default");
    } else {
      this.$store.commit("addRfid", this.rfid1);
      localStorage.setItem("saascadetechrfid", this.rfid1);
    }

    if (this.$store.state.currency == "" || this.$store.state.userId == "") {
      axios
        .get(
          "https://api.ipdata.co/?api-key=0ca44734c86ce347178a2aadfce99843c06f0261fefd02f6e70c2237"
        )
        .then(response => {
          if (response.data.currency.code == "AUD") {
            this.$store.commit("addCurrency", "AUD");
            this.$store.commit("addCurrencySymbol", "A$");
            this.$store.commit("addCountry", response.data.country_name);
          } else if(response.data.currency.code == "INR"){
            this.$store.commit("addCurrency", "INR");
            this.$store.commit("addCurrencySymbol", "₹");
            this.$store.commit("addCountry", response.data.country_name);
          }else if(response.data.currency.code == "PHP"){
            this.$store.commit("addCurrency", "PHP");
            this.$store.commit("addCurrencySymbol", "₱");
            this.$store.commit("addCountry", response.data.country_name);
          }else{
            this.$store.commit("addCurrency", "USD");
            this.$store.commit("addCurrencySymbol", "$");
            this.$store.commit("addCountry", response.data.country_name);
          }
        })
        .catch(error => {
          if (error != null) {
            this.$store.commit("addCurrency", "USD");
            this.$store.commit("addCurrencySymbol", "$");
            this.$store.commit("addCountry","United States");
          }
        });
    }
  },
  computed: {
    authenticated() {
      if (this.$store.state.userId == "") 
        return false;
      else 
        return true;
    },
    getName() {
      return this.$store.getters.displayName.charAt(0);
    },
    getBookmarkAmount() {
      return this.$store.state.shortListId.length;
    },
    getNotificationStatus() {
      this.fetchNotificationStatus();
      return this.$store.state.notifyStatus;
    }
  },
  methods: {
    fetchNotificationStatus() {
      let vm = this;
      if (this.$store.state.userId != "") {
        let notifyRef = db
          .collection("notification")
          .doc(this.$store.getters.userId);
        notifyRef.onSnapshot(function(doc) {
          let temp = doc.data();
          vm.$store.commit("addNotifyStatus", temp.read);
        });
      }
    }
  },

  props: {
    source: String
  },
  filters: {
    firstLetter: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
};
</script>


<style>
.list-item-group {
  margin: 5px !important  ;
  border-radius: 35px !important;
}

.rounded {
  border-radius: 35px !important;
}
.parallax {
   background-attachment:fixed;
   background-size: 100% auto;
 }
</style>
